import React from 'react';
import { Calendar } from 'lucide-react';
import ApiService from '../../services/apiService';

const SatelliteImage = ({ src, date, avg, t }) => (
    <div className="relative group overflow-hidden rounded-xl border border-gray-200 dark:border-slate-700 bg-gray-100 dark:bg-black transition-colors">
        <a href={`${ApiService.BASE_URL}${src}`} target="_blank" rel="noopener noreferrer">
            <img
                src={`${ApiService.BASE_URL}${src}`}
                style={{ imageRendering: 'pixelated' }}
                className="w-full h-64 object-contain bg-gray-100 dark:bg-black hover:scale-110 transition-transform duration-500 cursor-zoom-in"
                alt="Satellite"
            />
        </a>

        {/* Overlays */}
        <div className="absolute top-0 left-0 right-0 flex justify-between p-2 pointer-events-none">
            {/* LEFT: Date */}
            {date && (
                <span className="bg-white/80 dark:bg-black/70 backdrop-blur text-geo-navy dark:text-geo-olive text-xs px-2 py-1 rounded border border-gray-200 dark:border-white/10 flex items-center gap-1 transition-colors">
                    <Calendar size={10} /> {date}
                </span>
            )}

            {/* RIGHT: Average */}
            {avg && t && (
                <span className="bg-geo-olive text-white font-mono text-xs px-2 py-1 rounded shadow-lg border border-geo-olive/50">
                    {t.satellite?.avg || "Avg"}: {avg}
                </span>
            )}
        </div>
    </div>
);

export default SatelliteImage;
